export default "__VITE_ASSET__Tck40z1s__"